import jwtDecode from 'jwt-decode';

export function getBusinessIdFromToken(): number | string {
  const token = localStorage.getItem('_UFT_');
  if (!token) {
    return '';
  }
  try {
    const decodedToken = jwtDecode(token) as { business?: { id?: number } };
    return decodedToken?.business?.id || '';
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return '';
  }
}
